import { useMemo,useState,useEffect } from 'react';
import { useReadContract,useReadContracts } from 'wagmi';
import { abi as IERC20ABI } from '@openzeppelin/contracts/build/contracts/ERC20.json';
import { ethers, formatUnits } from 'ethers';
import BigNumber from 'bignumber.js';

import { getFourMemeTokenInfo, isTokenLaunched } from "@/request/meme";

// 定义返回的类型
interface TokenDetails {
  tokenAddress: `0x${string}`; // 确保地址是以0x开头的字符串
  name?: any;
  symbol?: any;
  decimals?: any;
  totalSupply?: BigNumber;
  formattedTotalSupply?: string;
  isError: boolean;
  isLoading: boolean;
  balance:any;
}

// 自定义 Hook，用于获取代币详细信息
export function useTokenDetails(tokenAddress: `0x${string}`): TokenDetails {
  // if(!tokenAddress){
  //   return {
  //     tokenAddress,
  //     name: undefined,
  //     symbol: undefined,
  //     decimals: undefined,
  //     totalSupply: undefined,
  //     formattedTotalSupply: undefined,
  //     isError: false,
  //     isLoading: false,
  //   }
  // } 
  // 使用 useReadContract 获取代币名称
  const { data: name, isError: nameError, isLoading: nameLoading } = useReadContract({
    address: tokenAddress,
    abi: IERC20ABI,
    functionName: 'name',
  });

  // 使用 useReadContract 获取代币符号
  const { data: symbol, isError: symbolError, isLoading: symbolLoading } = useReadContract({
    address: tokenAddress,
    abi: IERC20ABI,
    functionName: 'symbol',
  });

  // 使用 useReadContract 获取代币总供应量
  const { data: totalSupply, isError: totalSupplyError, isLoading: totalSupplyLoading } = useReadContract({
    address: tokenAddress,
    abi: IERC20ABI,
    functionName: 'totalSupply',
  });

  // 使用 useReadContract 获取代币小数位数
  const { data: decimals, isError: decimalsError, isLoading: decimalsLoading } = useReadContract({
    address: tokenAddress,
    abi: IERC20ABI,
    functionName: 'decimals',
  });

    // 使用 useReadContract 获取代币小数位数
  const { data: balance, isError: balanceError, isLoading: balanceLoading } = useReadContract({
    address: tokenAddress,
    abi: IERC20ABI,
    functionName: 'balance',
  });

  // 检查是否有任何错误
  const isError = nameError || symbolError || decimalsError || totalSupplyError;

  // 检查是否正在加载
  const isLoading = nameLoading || symbolLoading || decimalsLoading || totalSupplyLoading;

  // 如果 totalSupply 存在，将其转换为人类可读的格式
  const formattedTotalSupply = totalSupply ? formatUnits(totalSupply.toString(), 18) : undefined;

  // 转换 totalSupply 为 BigNumber
  const totalSupplyBigNumber = totalSupply ? new BigNumber(totalSupply.toString()) : undefined;

  return {
    tokenAddress, // 返回代币的地址
    name,
    symbol,
    decimals,
    totalSupply: totalSupplyBigNumber, // 返回转换后的 BigNumber 类型
    formattedTotalSupply, // 返回格式化后的 totalSupply 值（按 18 位小数）
    isError,
    isLoading,
    balance
  };
}

export function useTokenInfo(tokenAddress: `0x${string}`){
  const wagmigotchiContract = {
    address: tokenAddress,
    abi: IERC20ABI,
  } as const;
  let keys = ['name', 'symbol', 'decimals', 'totalSupply'];
  const contracts: any = useMemo(() => {
    return keys.map((key) => ({
      ...wagmigotchiContract,
      functionName: key,
    }));
  },[wagmigotchiContract])
  const { data: tokenInfo, isError: tokenInfoError, isLoading: tokenInfoLoading } = useReadContracts({
    contracts: contracts,
    query:{
      enabled: !!tokenAddress,
    }
  })
  // console.log('tokenInfo',tokenInfo);
  let info:any = {};
  if(!!tokenInfo){
    // console.log('tokenInfo >>>>>>',tokenInfo);
    keys.forEach((key,index) => {
      info[key] = tokenInfo?.[index]?.result
    })
  }
  // console.log('info',info);
  return {
    tokenInfo: info,
    tokenInfoError,
    tokenInfoLoading,
  }
}

// 检查代币是否开启转账
export function useTokenDisabledTransfer({
  dex,
  tokenAddress,
}:{
  dex: string;
  tokenAddress: `0x${string}`;
}){
  // console.log('dex,tokenAddress',dex,tokenAddress)
  const [tokenDisabledTransfer, setTokenDisabledTransfer] = useState<boolean>(false);//默认不禁用，启用转账功能

  useEffect(() => {
    if(dex === 'FourMeme' && !!tokenAddress && tokenAddress?.endsWith("4444")){
      getTokenInfo();
    }else{
      setTokenDisabledTransfer(false);
    }
  }, [dex,tokenAddress])

  const getTokenInfo = async() => {
    try{
      switch(dex){
        case 'FourMeme':
          const memeTokenInfo = await getFourMemeTokenInfo(tokenAddress);
          const isLaunched = isTokenLaunched(memeTokenInfo);
          setTokenDisabledTransfer(!isLaunched);
          break;
        default:
          setTokenDisabledTransfer(false);
      }
    }catch(error){
      console.error('获取代币信息失败:', error);
    }
  }
  return {
    status: tokenDisabledTransfer,
  }
}
